import FakeLink from "@/components/FakeLink/FakeLink";
import LocationSearch from "@/components/LocationSearch/LocationSearch";
import { UniqueRouteFacility as UniqueRouteAddress, UniqueRouteLeg } from "@/hooks/useTransport";
import { BankOutlined, CloseCircleOutlined, LinkOutlined } from "@ant-design/icons";
import { Button, Tooltip, Typography } from "antd";
import { useEffect, useState } from "react";
import styles from "./RouteWizard.module.scss";

const { Text } = Typography;

export default function FacilityLeg({
  address,
  leg,
  index,
  updateLeg,
  error,
  totalRoutesCount,
  type,
}: {
  address: UniqueRouteAddress | null;
  leg: UniqueRouteLeg;
  index: number;
  updateLeg: (index: number, leg: UniqueRouteLeg) => void;
  error: boolean | undefined;
  totalRoutesCount: number;
  type: "facility" | "customer";
}) {
  const [newAddress, setNewAddress] = useState(false);

  useEffect(() => {
    setNewAddress(address?.address !== leg.address || error === true);
  }, [address, leg, error]);

  return (
    <div className={[styles.leg, styles["arrival-departure"]].join(" ")}>
      <div className={styles.number}>
        <div className={styles["number-wrapper"]}>{index + 1}</div>
      </div>
      <div className={styles.facility}>
        <div className={styles["facility-name"]}>
          {address ? (
            <>
              {type === "facility" && <BankOutlined />}
              <Text
                className={styles.ellipsisTitle}
                style={{ width: 500 }}
                ellipsis={true}
              >
                {address.name}
              </Text>
            </>
          ) : (
            "Multiple locations"
          )}
        </div>
        {!address ? (
          <div className={styles["address"]}>
            <span>Multiple addresses ({totalRoutesCount} orders)</span>
          </div>
        ) : !newAddress ? (
          <>
            <div className={styles["facility-address"]}>
              <div className={styles["address"]}>
                <span>{address.address}</span>
                <Tooltip
                  title={`Address derived from ${type === "facility" ? "facility" : "sales order"}`}
                >
                  <LinkOutlined />
                </Tooltip>
              </div>
              <div className={styles.new}>
                <FakeLink onClick={() => setNewAddress(true)}>New address</FakeLink>
              </div>
            </div>
          </>
        ) : (
          <div className={styles["new-address"]}>
            <LocationSearch
              status={error ? "error" : undefined}
              style={{ flexGrow: 1, maxWidth: 540 }}
              value={leg.address}
              onChange={(value) => updateLeg(index, { ...leg, address: value })}
            />
            {address.address && (
              <Button
                onClick={() => {
                  setNewAddress(false);
                  updateLeg(index, { ...leg, address: address.address || "" });
                }}
                disabled={address.address === undefined}
                icon={<CloseCircleOutlined />}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}
